import { combineReducers } from 'redux'
import { LOGOUT_BEGIN } from 'src/actions/actionType'
import { ACCESS_TOKEN_NAME, PERSIST_ROOT } from 'src/constants/Constants'
import AppointmentStatusReducer from './AppointmentStatusReducer'
import AppointmentStatusesReducer from './AppointmentStatusesReducer'
import AppointmentTasksReducer from './AppointmentTasksReducer'
import AppointmentsReducer from './AppointmentsReducer'
import BillingReducer from './BillingReducer'
import CarriersReducer from './CarriersReducer'
import ClientPricingsReducer from './ClientPricingsReducer'
import ClientsReducer from './ClientsReducer'
import CountriesReducer from './CountriesReducer'
import CurrenciesReducer from './CurrencyReducer'
import CurrentUserReducer from './CurrentUserReducer'
import DeliveryStatusReducer from './DeliveryStatusReducer'
import DeliveryTypeReducer from './DeliveryTypeReducer'
import DepartmentsReducer from './DepartmentsReducer'
import DeviceReducer from './DeviceReducer'
import DoorTypeReducer from './DoorTypeReducer'
import ErrorsReducer from './ErrorsReducer'
import HolidayReducer from './HolidayReducer'
import InventoryCountItemsReducer from './InventoryCountItemsReducer'
import InventoryCountReducer from './InventoryCountReducer'
import InventoryCountsReducer from './InventoryCountsReducer'
import InventoryReducer from './InventoryReducer'
import InvoiceStatusReducer from './InvoiceStatusReducer'
import InvoicesReducer from './InvoicesReducer'
import ItemCategoriesReducer from './ItemCategoriesReducer'
import ItemConditionsReducer from './ItemConditionsReducer'
import ItemLinguisticsReducer from './ItemLinguisticsReducer'
import ItemReasonsReducer from './ItemReasonsReducer'
import ItemReducer from './ItemReducer'
import ItemStatusReducer from './ItemStatusReducer'
import ItemTypesReducer from './ItemTypesReducer'
import JobsReducer from './JobsReducer'
import LanguageReducer from './LanguageReducer'
import LengthClassReducer from './LengthClassReducer'
import LocationCategoryReducer from './LocationCategoryReducer'
import LocationReducer from './LocationReducer'
import ModificationTypesReducer from './ModificationTypesReducer'
import OrderReducer from './OrderReducer'
import OrderStatusReducer from './OrderStatusReducer'
import OrderTypesReducer from './OrderTypesReducer'
import PackingPreferencesReducer from './PackingPreferencesReducer'
import PermissionsReducer from './PermissionsReducer'
import PickingMethodsReducer from './PickingMethodsReducer'
import PickingReducer from './PickingReducer'
import ProcessingTypesReducer from './ProcessingTypesReducer'
import ProvincesReducer from './ProvincesReducer'
import PurchaseOrderItemReducer from './PurchaseOrderItemReducer'
import PurchaseOrderReducer from './PurchaseOrderReducer'
import QuantityTypesReducer from './QuantityTypesReducer'
import ReceivingItemConditionsReducer from './ReceivingItemConditionsReducer'
import ReceivingItemErrorsReducer from './ReceivingItemErrorsReducer'
import ReceivingItemReasonsReducer from './ReceivingItemReasonsReducer'
import ReceivingItemStatusesReducer from './ReceivingItemStatusesReducer'
import ReceivingPOReasonsReducer from './ReceivingPOReasonsReducer'
import ReceivingPOStatusesReducer from './ReceivingPOStatusesReducer'
import ReceivingReducer from './ReceivingReducer'
import ReceivingStatusReducer from './ReceivingStatusReducer'
import ReceivingTransactionsReducer from './ReceivingTransactionsReducer'
import ReplenishStatusReducer from './ReplenishStatusReducer'
import ReportsReducer from './ReportsReducer'
import ReturnReducer from './ReturnReducer'
import ReturnStatusReducer from './ReturnStatusReducer'
import RolesReducer from './RolesReducer'
import SalutationReducer from './SalutationReducer'
import SavedDataReducer from './SavedDataReducer'
import SettingsReducer from './SettingsReducer'
import ShippingMethodsReducer from './ShippingMethodsReducer'
import ShippingReducer from './ShippingReducer'
import SidebarReducer from './SidebarSlice'
import SuppliersReducer from './SuppliersReducer'
import SupplyTypesReducer from './SupplyTypesReducer'
import TaxClassesReducer from './TaxClassesReducer'
import TaxesReducer from './TaxesReducer'
import ThemeReducer from './ThemeSlice'
import TransactionTypesReducer from './TransactionTypesReducer'
import TransactionsReducer from './TransactionsReducer'
import UomReducer from './UomReducer'
import UsersReducer from './UsersReducer'
import WarehouseReducer from './WarehouseReducer'
import WeightClassReducer from './WeightClassReducer'
import ZoneCategoriesReducer from './ZoneCategoriesReducer'
import ZoneReducer from './ZoneReducer'
import TaxRatesReducer from './taxRatesReducer'
import TodoReducer from './TodoReducer'

const appReducer = combineReducers({
  auth: CurrentUserReducer,
  sidebar: SidebarReducer,
  settings: SettingsReducer,
  languages: LanguageReducer,
  themes: ThemeReducer,
  countries: CountriesReducer,
  provinces: ProvincesReducer,
  appointments: AppointmentsReducer,
  suppliers: SuppliersReducer,
  carriers: CarriersReducer,
  orderTypes: OrderTypesReducer,
  departments: DepartmentsReducer,
  devices: DeviceReducer,
  appointmentTasks: AppointmentTasksReducer,
  appointmentStatus: AppointmentStatusReducer,
  currencies: CurrenciesReducer,
  inventoryCount: InventoryCountReducer,
  inventoryCountItems: InventoryCountItemsReducer,
  inventoryCounts: InventoryCountsReducer,
  inventory: InventoryReducer,
  itemReasons: ItemReasonsReducer,
  modificationTypes: ModificationTypesReducer,
  warehouses: WarehouseReducer,
  purchaseOrders: PurchaseOrderReducer,
  purchaseOrderItem: PurchaseOrderItemReducer,
  shippingMethods: ShippingMethodsReducer,
  orderStatus: OrderStatusReducer,
  receivingStatus: ReceivingStatusReducer,
  returnStatus: ReturnStatusReducer,
  deliveryStatus: DeliveryStatusReducer,
  salutations: SalutationReducer,
  uom: UomReducer,
  locationCategories: LocationCategoryReducer,
  lengthClasses: LengthClassReducer,
  weightClasses: WeightClassReducer,
  supplyTypes: SupplyTypesReducer,
  itemTypes: ItemTypesReducer,
  itemStatus: ItemStatusReducer,
  jobs: JobsReducer,
  billing: BillingReducer,
  holidays: HolidayReducer,
  doorTypes: DoorTypeReducer,
  taxes: TaxesReducer,
  deliveryTypes: DeliveryTypeReducer,
  appointmentStatuses: AppointmentStatusesReducer,
  receivingItemReasons: ReceivingItemReasonsReducer,
  receivingItemStatuses: ReceivingItemStatusesReducer,
  receivingItemConditions: ReceivingItemConditionsReducer,
  receivingItemErrors: ReceivingItemErrorsReducer,
  receivingPOReasons: ReceivingPOReasonsReducer,
  receivingPOStatuses: ReceivingPOStatusesReducer,
  quantityTypes: QuantityTypesReducer,
  itemCategories: ItemCategoriesReducer,
  itemConditions: ItemConditionsReducer,
  itemLinguistics: ItemLinguisticsReducer,
  pickingMethods: PickingMethodsReducer,
  picking: PickingReducer,
  errors: ErrorsReducer,
  orders: OrderReducer,
  returns: ReturnReducer,
  clients: ClientsReducer,
  transactionTypes: TransactionTypesReducer,
  transactions: TransactionsReducer,
  savedData: SavedDataReducer,
  invoiceStatus: InvoiceStatusReducer,
  invoices: InvoicesReducer,
  processingTypes: ProcessingTypesReducer,
  zoneCategories: ZoneCategoriesReducer,
  replenishStatus: ReplenishStatusReducer,
  receivingTransactions: ReceivingTransactionsReducer,
  items: ItemReducer,
  receiving: ReceivingReducer,
  zones: ZoneReducer,
  shippings: ShippingReducer,
  clientPricings: ClientPricingsReducer,
  taxRates: TaxRatesReducer,
  taxClasses: TaxClassesReducer,
  permissions: PermissionsReducer,
  roles: RolesReducer,
  locations: LocationReducer,
  users: UsersReducer,
  reports: ReportsReducer,
  todo: TodoReducer,
  packingPreferences: PackingPreferencesReducer,
})

export default function rootReducer(state, action) {
  if (action.type === LOGOUT_BEGIN) {
    localStorage.removeItem(PERSIST_ROOT)
    localStorage.removeItem(ACCESS_TOKEN_NAME)
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}
